import {
  CreateBillDto,
  CreateOrderDto,
  UpdateBillDto,
} from "../entities/dto/order.dto";
import { PageParams } from "../entities/interfaces/misc";
import { Bill, Order } from "../entities/interfaces/order";
import Api, { ApiResponse } from "../utils/axios";
import { stringifyPageParams } from "../utils/helpers";

export const list = async (
  pageParams: PageParams
): Promise<ApiResponse<Order[]>> => {
  return await Api.get(
    `/orders?${new URLSearchParams(stringifyPageParams(pageParams))}`
  );
};

export const create = async (
  createOrderDto: CreateOrderDto
): Promise<ApiResponse<Order>> => {
  return await Api.post("/orders", createOrderDto);
};

export const createBill = async (
  createBillDto: CreateBillDto
): Promise<ApiResponse<Bill>> => {
  return await Api.post("/bills", createBillDto);
};

export const get = async (id: string): Promise<ApiResponse<Order>> => {
  return await Api.get(`/orders/${id}`);
};

export const deleteOrder = async (id: string): Promise<ApiResponse<Order>> => {
  return await Api.delete(`/orders/${id}`);
};

export const updatePayment = async (
  id: string,
  updateBillDto: UpdateBillDto
): Promise<ApiResponse<Bill>> => {
  return await Api.post(`/bills/${id}/updatePayment`, updateBillDto);
};

// export const update = async (
//   id: string,
//   updateServiceDto: UpdateServiceDto
// ): Promise<ApiResponse<Service[]>> => {
//   return await Api.patch(`/services/${id}`, updateServiceDto);
// };

const OrderService = {
  list,
  create,
  createBill,
  updatePayment,
  get,
  delete: deleteOrder,
};
export default OrderService;
